<mat-dialog-content>
  <alert message="Annex.ConflictGeneralInfo" alertType="info"></alert>

  <div class="conflicts-list">
    <h3>{{ 'Annex.ConflictsList' | translate }}</h3>

    @for (group of conflictGroups; track group.componentName) {
    <div class="conflict-group">
      <div class="component-header">
        <h4>{{ group.componentName | translate }}</h4>
      </div>

      @for (conflict of group.conflictingAnnexes; track conflict) {
      <div class="conflict-item">
        <div class="conflict-info">
          <span class="conflict-date"> {{ 'Annex.ConclusionDate' | translate }} {{ conflict.ConclusionDate | date: 'dd.MM.yyyy' }} </span>
          <span class="conflict-period">
            ({{ 'Annex.ValidPeriod' | translate }}: {{ conflict.StartDate | date: 'dd.MM.yyyy' }} @if (conflict.EndDate) { - {{ conflict.EndDate |
            date: 'dd.MM.yyyy' }} } @else { - {{ 'Annex.Indefinite' | translate }} })
          </span>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <alert message="Annex.ConflictExplanation" alertType="warning"></alert>

  <div class="confirmation-section">
    <mat-checkbox [(ngModel)]="isConfirmed"> {{ 'Annex.ConflictConfirmation' | translate }} </mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="!isConfirmed" (click)="onConfirm()">{{ 'Annex.GenerateAnnex' | translate }}</button>
</mat-dialog-actions>
